export interface RequestState<T> {
  scope: string | null;
  data: T | null;
  loading: boolean;
  error: string | null;
}

/** A stale success, failure or finally must never update the current screen. */
export function createLatestRequest<T>(
  publish: (state: RequestState<T>) => void
) {
  let version = 0;
  let abort: AbortController | null = null;
  let state: RequestState<T> = {
    scope: null,
    data: null,
    loading: false,
    error: null,
  };
  return {
    cancel() {
      version++;
      abort?.abort();
    },
    async run(scope: string, work: (signal: AbortSignal) => Promise<T>) {
      abort?.abort();
      abort = new AbortController();
      const signal = abort.signal;
      const request = ++version;
      state = {
        scope,
        data: state.scope === scope ? state.data : null,
        loading: true,
        error: null,
      };
      publish(state);
      try {
        const data = await work(signal);
        if (request !== version) return;
        state = { scope, data, loading: false, error: null };
      } catch (error) {
        if (request !== version) return;
        state = {
          ...state,
          loading: false,
          error:
            typeof error === 'object' &&
            error !== null &&
            'message' in error &&
            typeof error.message === 'string'
              ? error.message
              : 'No se pudieron cargar los datos',
        };
      }
      if (request === version) publish(state);
    },
  };
}
